export default "__VITE_PUBLIC_ASSET__b47740be__"